import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/auth.service';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { CommonService } from 'src/app/service/common.service';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import { MenuIdService } from 'src/app/service/menu-id.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginAggreementComponent } from '../../login-aggreement/login-aggreement.component';
import { AppTermsAndConditionsService } from 'src/app/service/cookie.service';
import { environment } from 'src/environments/environment';
const TOKEN_KEY = 'Uad-Token';
const REFRESH_TOKEN = 'Refresh-Token'
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  submitted = false;
  isGoogleAuthenticatorRegistered: boolean = false;
  barcodeImageUrl: string = '';
  isShowAuthenticator: boolean = false;
  getuserAuthentication: any = [];
  orgAppID: any;
  otpPromptMessage: string = '';
  authenticationUniqueCode: string = '';
  imageURL!: Observable<string>;
  url: any;
  welcomeMsg: any;
  otp:any;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private loader: LoaderService,
    private restService: RestService,
    private translate: TranslateService,
    public router: Router,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private termsConditions: AppTermsAndConditionsService,
    private commonService: CommonService, public menuIdService: MenuIdService,
    private dialog: MatDialog ) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    if (this.router.url.includes('logOut')){
      window.localStorage.removeItem(TOKEN_KEY);
      window.localStorage.removeItem(REFRESH_TOKEN);
    }
    this.imageURL = this.menuIdService.getActiveImageURL();
    this.welcomeMsg = this.menuIdService.getActiveWelcomeMsg();
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.pattern(/^\s*[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\s*$/)]],
      password: ['', Validators.required]
    })
    this.route.queryParams.subscribe(params => {
      this.url = params['redirect_url'];
    });
  }
 
  get control() {
    return this.loginForm.controls
  }

  login() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    let params = {
      emailID: this.control['username'].value.trim(),
      password: this.control['password'].value
    }
    const redirectUrl = this.cookieService.get('redirect_url');
    this.loader.show();
    this.restService.postUATData(params, 'api/digital/core/Account/Login').subscribe({
      next: (data: any) => {
        this.loader.hide();
        if (data.rcode == 200) {
          this.authService.saveRefreshToken(data.rObj.refreshToken);
          this.authService.b2cAttemptAuth(data.rObj.token);
          let redirectUrl = data.rObj.redirectURL
          if(!this.termsConditions.getConsentCookie() && redirectUrl.includes('csr')){
            let _dialogRef = this.dialog.open(LoginAggreementComponent, {
              width: '80VW',
              disableClose: true,
            });
            _dialogRef.afterClosed().subscribe(result => {
              console.log(result)
              if (result) {
                if (this.url) {
                  const decodedUrl = decodeURIComponent(this.url);
                  window.location.href = redirectUrl; // Redirect to the decoded URL
                } else {
                  this.router.navigate(['/home']);
                }
              }
            });
          }
          else{
            if (this.url) {
              const decodedUrl = decodeURIComponent(this.url);
              window.location.href = redirectUrl; // Redirect to the decoded URL
            } else {
              window.location.href = redirectUrl;
            }
          }
        }
        else if (data.rcode == 203) {
          if(!this.termsConditions.getConsentCookie() && redirectUrl.includes('csr')){
          let _dialogRef = this.dialog.open(LoginAggreementComponent, {
            width: '80VW',
            disableClose: true,
          });
          _dialogRef.afterClosed().subscribe(result => {
            console.log(result)
            if (result) {
             this.authendicator(data)
            }
          });
        }
        else{
          this.authendicator(data)
        }
        }
      },
      error: (error: any) => {
        this.loader.hide();
        let errorCode = error.error.rmsg[0].errorCode ?? 'ERROR'
        this.commonService.apiErrorMessageDialog(error.error.trnID, errorCode);
      }
    })
  }
authendicator(data){
  this.isGoogleAuthenticatorRegistered = data.rObj.isGoogleAuthenticatorRegistered;
  this.barcodeImageUrl = data.rObj.barcodeImageUrl;
  this.getuserAuthentication = data.rObj.fetchUserLoginAuthenticationDetails;
  this.isShowAuthenticator = true;
  this.otpPromptMessage = data.rObj.message;
  this.authenticationUniqueCode = data.rObj.authenticationUniqueCode;
  this.otp = data.rObj.OTP;
}
}
